import { Box } from "@mui/material";
import MarvyPricingMay23 from "components/MarvyPricingMay23";
import { MT } from "components/MarvyTypography";
import WebsiteV2 from "layouts/WebsiteV2";
import React from "react";

export default function PricingPage() {
  const dotMatrix = React.useMemo(() => {
    return new Array(60).fill(0).map((_, i) =>
      new Array(20).fill(0).map((_, j) =>
        j * j * 0.15 > i ? (
          <circle
            cx={10 + j * 15}
            cy={10 + i * 15}
            r="2.5"
            // key={i + "" + j}
            style={{
              fill: Math.random() < 0.02 ? "#FF6666" : "#139A43",
            }}
          ></circle>
        ) : null
      )
    );
  }, []);

  return (
    <WebsiteV2>
      <Box
        component="svg"
        width="305px"
        height="850px"
        sx={{
          position: "absolute",
          right: "0px",
          top: { xs: "60px", lg: "110px" },
          zIndex: -1,
          opacity: 0.5,
        }}
      >
        {dotMatrix}
      </Box>
      <MT
        variant="h2"
        sx={{
          fontWeight: "700",
          color: "black",
          fontSize: {
            xs: "1.8rem",
            md: "3rem",
          },
          fontFamily: "'Open Sans', sans-serif",
          display: "inline",
          mb: 4,
          mt: 4,
        }}
        align="start"
      >
        Features and Pricing
      </MT>
      <MarvyPricingMay23 />
      <Box sx={{ mb: 20 }} />
    </WebsiteV2>
  );
}
